import { omit } from 'lodash';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { usePlayerStore } from '@air/component-player';

import { QueryParamNames } from '~/constants/search';

export const useVideoVisualizerSearchParamSync = () => {
  const router = useRouter();
  const videoElement = usePlayerStore((state) => state.videoElement);
  // HLS.js clobbers any currentTime set before `loadedmetadata` fires; PlayerSync gates that on `ready`.
  const ready = usePlayerStore((state) => state.ready);

  useEffect(() => {
    const timestamp =
      typeof router.query[QueryParamNames.timestamp] === 'string'
        ? parseFloat(router.query[QueryParamNames.timestamp])
        : undefined;

    if (timestamp !== undefined && !Number.isNaN(timestamp) && videoElement && ready) {
      videoElement.currentTime = timestamp;

      router.replace({
        pathname: router.pathname,
        query: omit(router.query, QueryParamNames.timestamp),
      });
    }
  }, [videoElement, ready, router.query, router.pathname, router.replace]);
};
